import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

export default function Reviews() {
  return (
    <div>
      <Header />
      <h1>ЗДЕСЬ БУДУТ ОТЗЫВЫ</h1>
      <Footer />
    </div>
  );
}
